export default __webpack_public_path__ + "static/Harvester5-29236b9160b7a91d0b6c0c876a036369.jpg";